"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _excluded = ["name", "size"];
var Wrapper = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "Icon__Wrapper",
  componentId: "sc-6ikg2d-0"
})(["& > i{font-family:\"EngagingTechIcons\";font-weight:normal;font-style:normal;font-size:", "px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:\"liga\";user-select:none;transition:0.18s;}"], function (_ref) {
  var size = _ref.size;
  return size;
});

var Icon = function Icon(_ref2) {
  var name = _ref2.name,
      size = _ref2.size,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, (0, _extends2["default"])({}, props, {
    alignItems: "center",
    justifyContent: "center",
    width: size,
    height: size,
    size: size
  }), /*#__PURE__*/_react["default"].createElement("i", null, name));
};

Icon.defaultProps = {
  color: "dark.2",
  size: 20
};
var _default = Icon;
exports["default"] = _default;